module.exports = __webpack_public_path__ + "static/media/img_image_haniwas.5d36e8d4.svg";